<template>
    <!-- 核验 -->
    <section class="checkLayout">
        <Result ref="resultNode" :resultInfo="resultInfo" />
        <div class="main">
            <h1>电子送达文书核验</h1>
            <el-divider></el-divider>
            <el-form :model="form" inline label-width="80px">
                <el-form-item label="存证文件" required>
                    <el-upload class="upload-demo" name="uploadFile" drag action="" ref="upload" :file-list="fileList"
                        :limit="1" :http-request="uploadSectionFile">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" slot="tip">您可以将电子送达文书直接上传进行核验（支持.txt，.doc，.pdf格式）</div>
                    </el-upload>
                </el-form-item>
                <div class="flex">
                    <el-form-item label="验证码" required>
                        <el-input v-model="form.imgCode" placeholder="请输入验证码" name="imgCode" style="width: 120px;" />
                    </el-form-item>
                    <div class="login_code_box">
                        <div class="img">
                            <img @click="getCodeFn" :src="imgPath" />
                        </div>
                        <div class="btn">
                            <span @click="getCodeFn">换一张</span>
                        </div>
                    </div>
                </div>
            </el-form>
            <img src="@/assets/img/home/ks.png" :class="btnFlag ? 'imgShow' : 'imgGray'" width="220"
                @click="btnFlag ? UpLoadFn() : ''" />
        </div>
    </section>
</template>

<script>
import apiObj from "../../api/index.js"
import Result from "./result.vue"

export default {
    data() {
        return {
            resultInfo: {},
            fileInfo: {},
            btnFlag: false,
            fileList: [],
            form: { imgCode: '' },
            imgPath: "",
            imgKey: '',
        }
    },
    methods: {
        // 清空list列表
        clearFile() {
            this.$nextTick(() => {
                this.$refs.upload.clearFiles();
            });
        },
        // 自定义上传前的校验
        async uploadSectionFile(params) {
            console.log(params)
            const file = params.file,
                isCode = this.form.imgCode;
            // 1、校验验证码是否为空
            if (!isCode) {
                this.$message.error("请先填写验证码，再上传文件!");
                this.clearFile()
                return false;
            }
            // 2、校验格式限制只能是pdf
            const isPDF = file.type == 'text/plain' || file.type == 'application/msword' || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type == 'application/pdf';
            if (!isPDF) {
                this.$message.error('上传文件支持.txt，.doc，.pdf格式!');
                this.clearFile()
                return false;
            }
            // 3、校验验证码是否正确
            try {
                const { code, message } = await apiObj.api.getImgValidateByKey({ imgCode: this.form.imgCode, imgKey: this.imgKey })
                if (code == 200) {
                    // 验证成功
                    this.$message.success(message)
                    console.log(file)
                    this.fileInfo = file
                    this.btnFlag = true
                } else {
                    this.$message.error(message)
                    this.getCodeFn()
                    this.clearFile()
                    this.btnFlag = false
                }
            } catch (e) {
                this.$message.error(message)
                this.getCodeFn()
                this.clearFile()
                this.btnFlag = false
            }
        },
        // 校验文书
        async UpLoadFn() {
            this.btnFlag = false
            console.log(this.fileInfo)
            // 根据后台需求数据格式
            let form = new FormData();
            // 文件对象
            form.append("uploadFile", this.fileInfo);
            try {
                const res = await apiObj.api.imageUpload(form)
                this.btnFlag = true
                this.resultInfo = {}
                const { code, data, message } = res.data
                this.resultInfo.name = this.fileInfo.name
                console.log(code, data, message)
                if (res.code == 0) {
                    if (code == 200) {
                        // 接口字段 vefifyTime（ISO：2026-05-11T16:06:05）→ 展示用空格分隔
                        this.resultInfo.czsj = formatIsoDateTime(data.vefifyTime)
                        this.resultInfo.hash = res.hash
                        this.resultInfo.type = 'tongguo'
                        this.open('success.jpg')
                    } else {
                        this.resultInfo.type = 'shibai'
                        this.open('error.jpg')
                    }
                } else {
                    this.$message.error(message)
                    this.resultInfo.type = 'shibai'
                    this.open('error.png')
                }
            } catch (e) {
                this.btnFlag = true
            }
        },
        // 弹出结果页
        open(val) {
            this.$refs.resultNode.open(val)
            // this.$alert(`<div style="width: 100%" class="tac"><img src='@/assets/img/check/${val}' width='100%' />
            //     </div>`, '查询结果', {
            //     dangerouslyUseHTMLString: true,
            //     showConfirmButton: false,
            //     customClass: 'myMessage'
            // });
        },
        // 获取验证码
        async getCodeFn() {
            const res = await apiObj.api.getImgValidateCode();
            const { code, data } = res;
            if (code === 200) {
                this.imgPath = data.imgPath;
                this.imgKey = data.imgKey;
            }
        },
    },
    components: {
        Result
    },
    created() {
        scroll(0, 0)
        this.getCodeFn()
    }
}

/** ISO 时间转展示：2026-05-11T16:06:05 → 2026-05-11 16:06:05 */
function formatIsoDateTime(value) {
    if (value == null || value === '')
        return ''
    return String(value).trim().replace('T', ' ')
}
</script>

<style lang="less">
@import "../../style/common.less";
</style>

<style lang="less">
.myMessage {
    width: auto !important;

    .el-message-box__message {
        width: 520px;
        margin: 0 auto;
    }
}

@media (max-width: 768px) {

    .myMessage {
        .el-message-box__message {
            width: 90%;
            margin: 0 auto;
        }
    }

}
</style>
<style lang="less" scoped>
.imgGray {
    filter: grayscale(100%);
    opacity: 0.7;
}

.imgShow {
    cursor: pointer;
}

.checkLayout {


    .main {
        width: 700px;
        height: 600px;
        margin: 80px auto 0;
        background-color: #fff;
        border-radius: 12px;
        border-right: 16px solid #437fec;
        padding: 42px 40px;
        box-shadow: 0 0 20px 5px rgba(0, 0, 0, .1);


        &>img {
            margin: 40px 0 0 80px;
        }
    }

    .login_code_box {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 20px;

        .btn {
            width: 100px;
            text-align: center;
            color: #999;
            cursor: pointer;
        }

    }

}

@media (max-width: 768px) {
    .checkLayout {
        .main {
            width: 100%;
            height: auto;
            padding: 40px 20px;
        }

        .login_code_box {
            margin-bottom: 0;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/check/index.vue